export type ProviderKey = "m3u" | "jellyfin" | "plex" | "xtream" | "stalker";

export interface ServerPickerProps {
  onSelect: (provider: ProviderKey) => void;
}

const PROVIDERS: Array<{ key: ProviderKey; label: string; description: string }> = [
  { key: "m3u", label: "M3U / M3U8 Playlist", description: "Paste a playlist URL" },
  { key: "jellyfin", label: "Jellyfin", description: "Self-hosted media server" },
  { key: "plex", label: "Plex", description: "Connect via plex.tv" },
  { key: "xtream", label: "Xtream Codes", description: "Server URL + username + password" },
  { key: "stalker", label: "Stalker Portal", description: "Portal URL + MAC address" },
];

export function ServerPicker({ onSelect }: ServerPickerProps) {
  return (
    <div style={{ padding: 24 }}>
      <h2>Add a server</h2>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))", gap: 12 }}>
        {PROVIDERS.map((p) => (
          <button
            key={p.key}
            onClick={() => onSelect(p.key)}
            style={{ background: "#222", color: "#fff", border: "1px solid #444", padding: 16, textAlign: "left", cursor: "pointer" }}
          >
            <div style={{ fontWeight: 600 }}>{p.label}</div>
            <div style={{ fontSize: 12, color: "#888", marginTop: 4 }}>{p.description}</div>
          </button>
        ))}
      </div>
    </div>
  );
}
